module.exports = __webpack_public_path__ + "img/Retail4.04a41e8f.png";